module.exports = __webpack_public_path__ + "static/img/result_bg.3cfbb9bb.png";